import { useLoadScript } from '@react-google-maps/api';
import { librariesList } from 'app/common/librariesList';
import { DealerListContext } from 'app/components/ReactContexts/dealerListContext';
import { GlobalErrorContext } from 'app/components/ReactContexts/globalErrorContext';
import { WordmarkLoader } from 'app/components/loaders';
import { axiosInstance } from 'services/api';
import { useAuth } from 'context';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @deprecated This component is a temporary solution until dealers fetching is replaced with RTK Query.
 */
export function DealersNotLoaded() {
  const { setDealerListData } = useContext(DealerListContext);
  const { addErrorModal } = useContext(GlobalErrorContext);

  const { t } = useTranslation();

  const { isAuthenticated } = useAuth();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.GOOGLE_API_KEY as string,
    libraries: librariesList,
  });

  useEffect(() => {
    if (isAuthenticated) {
      axiosInstance
        .get(`/api/user/dealer`, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .catch(err => {
          addErrorModal();
        })
        .then((response: any) => {
          setDealerListData(oldState => ({
            ...oldState,
            favoriteDealers: response.data,
          }));
        });
    } else {
      setDealerListData(oldState => ({
        ...oldState,
        favoriteDealers: [],
      }));
    }
  }, []);

  useEffect(() => {
    setDealerListData(oldState => ({
      ...oldState,
      isMapLoaded: isLoaded,
    }));
  }, [isLoaded]);

  return <WordmarkLoader title={t('loading_dealers...')} />;
}
